"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotComplexEmpty = exports.isComplexEmpty = exports.isEmpty = exports.isNotEmpty = exports.isNotNull = exports.isNull = exports.isNotUndefined = exports.isUndefined = void 0;
function isUndefined(value) {
    if (value === undefined) {
        return true;
    }
    return false;
}
exports.isUndefined = isUndefined;
function isNotUndefined(value) {
    return !isUndefined(value);
}
exports.isNotUndefined = isNotUndefined;
function isNull(value) {
    if (value === null) {
        return true;
    }
    return false;
}
exports.isNull = isNull;
function isNotNull(value) {
    return !isNull(value);
}
exports.isNotNull = isNotNull;
function isNotEmpty(value) {
    return isNotUndefined(value) && isNotNull(value);
}
exports.isNotEmpty = isNotEmpty;
function isEmpty(value) {
    return isUndefined(value) || isNull(value);
}
exports.isEmpty = isEmpty;
/**
 * 인자가 빈 값이면 true를 반환한다. 숫자 일 경우에는 NaN 검사, 문자열일 경우에는 빈 문자열 검사,
 * 배열인 경우 길이가 1보다 작은지 검사, 오브젝트인 경우 키가 1개 이상인지 검사하는 추가 검사항목이
 * 포함되어 있다.
 *
 * @param value 빈 값인지 검사하고 싶은 값
 */
function isComplexEmpty(value) {
    if (value === undefined || value === null) {
        return true;
    }
    if (typeof value === 'number' && isNaN(value)) {
        return true;
    }
    if (typeof value === 'string' && value === '') {
        return true;
    }
    if (typeof value === 'object' && Array.isArray(value) && value.length < 1) {
        return true;
    }
    if (typeof value === 'object' && !(value instanceof Date) && Object.keys(value).length < 1) {
        return true;
    }
    return false;
}
exports.isComplexEmpty = isComplexEmpty;
/**
 * 인자가 빈 값이 아니면 true를 반환한다. 숫자 일 경우에는 NaN 검사, 문자열일 경우에는 빈 문자열 검사,
 * 배열인 경우 길이가 1보다 작은지 검사, 오브젝트인 경우 키가 1개 이상인지 검사하는 추가 검사항목이
 * 포함되어 있다.
 *
 * @param value 빈 값 아닌지 검사하고 싶은 값
 */
function isNotComplexEmpty(value) {
    return !isComplexEmpty(value);
}
exports.isNotComplexEmpty = isNotComplexEmpty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1wdHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZW1wdHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsU0FBZ0IsV0FBVyxDQUFJLEtBQXFCO0lBQ2xELElBQUksS0FBSyxLQUFLLFNBQVMsRUFBRTtRQUN2QixPQUFPLElBQUksQ0FBQztLQUNiO0lBRUQsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDO0FBTkQsa0NBTUM7QUFFRCxTQUFnQixjQUFjLENBQUksS0FBcUI7SUFDckQsT0FBTyxDQUFDLFdBQVcsQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUM3QixDQUFDO0FBRkQsd0NBRUM7QUFFRCxTQUFnQixNQUFNLENBQUksS0FBZ0I7SUFDeEMsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2xCLE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFFRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUM7QUFORCx3QkFNQztBQUVELFNBQWdCLFNBQVMsQ0FBSSxLQUFnQjtJQUMzQyxPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ3hCLENBQUM7QUFGRCw4QkFFQztBQUVELFNBQWdCLFVBQVUsQ0FBSSxLQUE0QjtJQUN4RCxPQUFPLGNBQWMsQ0FBQyxLQUFLLENBQUMsSUFBSSxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDbkQsQ0FBQztBQUZELGdDQUVDO0FBRUQsU0FBZ0IsT0FBTyxDQUFJLEtBQTRCO0lBQ3JELE9BQU8sV0FBVyxDQUFDLEtBQUssQ0FBQyxJQUFJLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUM3QyxDQUFDO0FBRkQsMEJBRUM7QUFFRDs7Ozs7O0dBTUc7QUFDSCxTQUFnQixjQUFjLENBQUksS0FBNEI7SUFDNUQsSUFBSSxLQUFLLEtBQUssU0FBUyxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDekMsT0FBTyxJQUFJLENBQUM7S0FDYjtJQUVELElBQUksT0FBTyxLQUFLLEtBQUssUUFBUSxJQUFJLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUM3QyxPQUFPLElBQUksQ0FBQztLQUNiO0lBRUQsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksS0FBSyxLQUFLLEVBQUUsRUFBRTtRQUM3QyxPQUFPLElBQUksQ0FBQztLQUNiO0lBRUQsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsSUFBSSxLQUFLLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtRQUN6RSxPQUFPLElBQUksQ0FBQztLQUNiO0lBRUQsSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksQ0FBQyxDQUFDLEtBQUssWUFBWSxJQUFJLENBQUMsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUU7UUFDMUYsT0FBTyxJQUFJLENBQUM7S0FDYjtJQUVELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQztBQXRCRCx3Q0FzQkM7QUFFRDs7Ozs7O0dBTUc7QUFDSCxTQUFnQixpQkFBaUIsQ0FBSSxLQUE0QjtJQUMvRCxPQUFPLENBQUMsY0FBYyxDQUFJLEtBQUssQ0FBQyxDQUFDO0FBQ25DLENBQUM7QUFGRCw4Q0FFQyJ9